import React, { useContext, useState, useEffect } from "react";
import { CommonModal } from "../../../AbstractElements";
import { Label, Form, FormGroup, Row, Col } from "reactstrap";
import Select from "react-select";
import { showAlert } from "../../../Services/Shared.service";
import SharedDataContext from "../../../_helper/SharedData";
import {
  updateDriverScheme,
  getDriverSchemeById,
  getSchemeDeductionsById,
  updateSchemeDeduction,
} from "../../../Services/Driver.service";
import { useForm } from "react-hook-form";
import CustomizerContext from "../../../_helper/Customizer";
import { ArrowDown, ArrowUp, Watch } from "react-feather";

function DriverShcemeDeductionEdit({
  editId,
  isModal,
  closeModal,
  triggerRefresh,
}) {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    reset,
    watch,
  } = useForm({
    defaultValues: {},
  });
  const { ServiceCity, Packages,ValueType,CorprateClient, BookingType,DeductionValue ,IsDisplay} = watch();
  // const { ServiceCity } = watch();
  const { mix_background_layout } = useContext(CustomizerContext);
  const { cityData } = useContext(SharedDataContext);
  const [driverScheme,setDriverScheme] = useState();
  const [isAdvanced, setIsAdvanced] = useState(false);
  const [selectedScheme,setSelectedScheme] = useState({});

  useEffect(() => {
if(editId){ 
  getSchemeDeductionsById(editId).then((resp) => {
  setSelectedScheme(resp.data)
  // showAlert("success","fetched succesfully")
  reset({

    ServiceCity: resp
      ? cityData.find(
          (element) => element.id === resp.data.serviceCityId
        )
      : { label: "Select Service City", value: "" },
    DeductionValue: resp.data.value,
    ValueType: ValueTypeArr.find(
      (item) => item.value === resp.data.valueType
    ),
    BookingType: bookingTypes.find(
      (item) => item.value === resp.data.bookingTypeDeduction
    ),
    IsDisplay: resp.data.isDeleted ? true : false,
  });
});
}
  }, [editId]);

  useEffect(()=>{
    reset({
      ServiceCity: selectedScheme
      ? cityData.find(
          (element) => element.id === selectedScheme.serviceCityId
        )
      : { label: "Select Service City", value: "" },
      DriverType:selectedScheme?selectedScheme.driverSchemeName:"",
      DeductionValue:selectedScheme.value,
      DeductionType:selectedScheme?selectedScheme.driverDeductionName:"",
      ValueType:ValueTypeArr.find((item)=>item.value === selectedScheme.valueType),
      BookingType:bookingTypes.find((item)=>item.value === selectedScheme.bookingDeduction),
      IsDisplay:selectedScheme.isDeleted?true:false,
      createdOn:selectedScheme?.createdOn ?selectedScheme?.createdOn:null,
      createdById:selectedScheme?.createdById ?selectedScheme?.createdById:null,
      deletedById:selectedScheme?.deletedById ?selectedScheme?.deletedById:null,
      deletedOn:selectedScheme?.deletedOn ?selectedScheme?.deletedOn:null,
    })
  },[selectedScheme])

  const handleDeductionSubmit = (formValues) => {
    const body = {
      driverSchemeId: selectedScheme?selectedScheme.driverSchemeId:null,
      driverDeductionId:  selectedScheme?selectedScheme.driverDeductionId:null,
      valueType: formValues ? formValues.ValueType.value : "",
      value: formValues ? formValues.DeductionValue : "",
      serviceCityId:formValues.ServiceCity.id,
      bookingDeduction:formValues?formValues.BookingType.value:"",
      createdOn:formValues?.createdOn,
      createdById:formValues?.createdById?formValues.createdById:"",
      deletedById:formValues?.deletedById ?selectedScheme?.deletedById:null,
      deletedOn:formValues?.deletedOn ?selectedScheme?.deletedOn:null,
      // corporateClientId:formValues?formValues.CorprateClient.id:null,
      // packagesId:formValues?formValues.Packages.id:null,
  };
      body["id"] = selectedScheme.id;
      updateSchemeDeduction(body).then((resp)=>{
        closeModal()
        showAlert("success","Updated Successfully")
        triggerRefresh()
      }).catch((err) => {
        showAlert("error", "Something went wrong");
      });
}

const ValueTypeArr = [
  { label: "Percentage", value: "P" },
  { label: "Amount", value: "A" },
];

const bookingTypes = [
  { label: "MobileApp", value: "MobileApp" },
  { label: "DriverApp", value: "DriverApp" },
  { label: "Website", value: "Website" },
  { label: "PartnerApi", value: "PartnerApi" },
  { label: "CustomerService", value: "CustomerService" },
  { label: "IRCTC", value: "IRCTC" },
  { label: "BookingWeb", value: "BookingWeb" },
  { label: "JustDial", value: "JustDial" },
  { label: "Integrator", value: "Integrator" },
  { label: "AirportBooking", value: "AirportBooking" },
  { label: "City", value: "City" },
  { label: "CRON", value: "CRON" },
  { label: "All", value: "All" },
  { label: "Others", value: "Others" },
  { label: "CallCenter", value: "CallCenter" },
];
  return (
    <CommonModal
    isOpen={isModal}
    title={"Edit Driver Configurations"}
    toggler={() => {
      closeModal()
    }}
    size="xl"
    >
      <Form onSubmit={handleSubmit(handleDeductionSubmit)}>
        <Row>
          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">DriverScheme</Label>
              <Col lg="12">
                  <input
                  disabled
                  // value={DriverType}
                    className="form-control"
                    type="text"
                    {...register("DriverType", {
                      onChange: (e) => {
                        setValue("DriverType", e.target.value.trimStart());
                      },
                    })}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.DriverType?.message}
                  </span>
              </Col>
        </FormGroup>

              <FormGroup className="col-lg-4">
                <Label className="col-lg-12 col-form-label">
                  Deduction Type
                </Label>
                <Col lg="12">
                  <input
                  disabled
                    className="form-control"
                    type="text"
                    {...register("DeductionType", {
                     
                      onChange: (e) => {
                        setValue("DeductionType", e.target.value.trimStart());
                      },
                    })}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.DeductionType?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-4">
                <Label className="col-lg-12 col-form-label">Value Type</Label>
                <Col lg="12">
                  <Select

                  value={ValueType}
                    options={ValueTypeArr}
                    {...register("ValueType", {
                      required: {
                        value: true,
                        message: "ValueType is required",
                      },
                    })}
                    onChange={(e) => setValue("ValueType",e)}
                    placeholder={"Select Value Type"}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.ValueType?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-4">
                <Label className="col-lg-12 col-form-label">
                  Deduction Value
                </Label>
                <Col lg="12">
                  <input
                  value={DeductionValue}
                    className="form-control"
                    type="text"
                    {...register("DeductionValue", {
                      required: {
                        value: true,
                        message: "DeductionValue is required",
                      },
                      onChange: (e) => {
                        setValue("DeductionValue", e.target.value.trimStart());
                      },
                    })}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.DeductionValue?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-4">
                <Label className="col-lg-12 col-form-label">Service City</Label>
                <Col lg="12">
                  <Select
                    value={ServiceCity}
                    options={cityData}
                    {...register("ServiceCity", {
                      required: {
                        value: true,
                        message: "ServiceCity is required",
                      },
                    })}
                    placeholder={"Select Service City"}
                    onChange={(e) => setValue("ServiceCity", e)}
                    isDisabled
                  />
                  <span style={{ color: "red" }}>
                    {errors?.ServiceCity?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-4">
                <Label className="col-lg-12 col-form-label">Booking Type</Label>
                <Col lg="12">
                  <Select
                    value={BookingType}
                    options={bookingTypes}
                    {...register("BookingType", {
                      required: {
                        value: true,
                        message: "BookingType is required",
                      },
                    })}
                    placeholder={"Select BookingType"}
                    onChange={(e) => setValue("BookingType", e)}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.BookingType?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup
                className="col-lg-4"
                style={{ display: "flex", alignItems: "center" }}
              >
                <div
                  className={
                    mix_background_layout == "dark-only"
                      ? "checkbox-dark p-0"
                      : "checkbox p-0"
                  }
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                  checked={IsDisplay}
                    style={{
                      width: "1.5rem",
                      height: "1.5rem",
                    }}
                    id="IsDisplay"
                    type="checkbox"
                    {...register("IsDisplay", {})}
                  />

                  <Label className="mb-0" for="IsDisplay">
                    {"IsDisplay"}
                  </Label>
                </div>
              </FormGroup>
            </Row>
            <Row>
              <div
                style={{
                  color: "#11BF5C",
                  textDecoration: "underline",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => setIsAdvanced(!isAdvanced)}
              >
                Advanced Configurations{" "}
                {isAdvanced ? (
                  <ArrowUp
                    style={{ width: "15px", height: "15px", marginLeft: "5px" }}
                  />
                ) : (
                  <ArrowDown
                    style={{ width: "15px", height: "15px", marginLeft: "5px" }}
                  />
                )}
              </div>
            </Row>
            {isAdvanced ? (
              <Row>
                <FormGroup className="col-lg-4">
                  <Label className="col-lg-12 col-form-label">
                    Corporate Clients
                  </Label>
                  <Col className="col-lg-12">
                    {/* <AsyncSelect
                    loadOptions={getCorporateClientOpt}
                      value={
                        CorprateClient
                          ? CorprateClient
                          : { label: "Search Corporate Client", value: "" }
                      }
                      {...register("CorprateClient", {})}
                      onChange={(e) => setValue("CorprateClient", e)}
                      placeholder={"Search Corporate Clients"}
                    /> */}
                  </Col>
                </FormGroup>

                <FormGroup className="col-lg-4">
                  <Label className="col-lg-12 col-form-label">Packages</Label>
                  <Col className="col-lg-12">
                    {/* <AsyncSelect
                    loadOptions={getPackageOptions}
                      value={
                        Packages
                          ? Packages
                          : { label: "Search Packages", value: "" }
                      }
                      {...register("Packages", {})}
                      onChange={(e) => setValue("Packages", e)}
                      placeholder={"Search Packages"}
                    /> */}
                  </Col>
                </FormGroup>

                <FormGroup className="col-lg-4">
                  <Label className="col-lg-12 col-form-label">
                    Minimum Distance
                  </Label>
                  <Col className="col-lg-12">
                    <input
                      className="form-control"
                      type="number"
                      {...register("minDistance", {
                        onChange: (e) => {
                          setValue("minDistance", e.target.value.trimStart());
                        },
                      })}
                    />
                  </Col>
                </FormGroup>

                <FormGroup className="col-lg-4">
                  <Label className="col-lg-12 col-form-label">
                    Maximum Distance
                  </Label>
                  <Col className="col-lg-12">
                    <input
                      className="form-control"
                      type="number"
                      {...register("maxDistance", {
                        onChange: (e) => {
                          setValue("maxDistance", e.target.value.trimStart());
                        },
                      })}
                    />
                  </Col>
                </FormGroup>
              </Row>
            ) : null}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "3rem",
              }}
            >
              <button type="submit" className="btn submit-button">
                {"Update"}
              </button>
            </div>
          </Form>
    </CommonModal>
  );
}

export default DriverShcemeDeductionEdit;
